import ru from './ru/index';
import en from './en/index';

export default {
  ru,
  en
};
